import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import { Container, Card, Col, Row } from 'react-bootstrap';

export const Subscription = () => {

	return <Container className="pt-3">
				<Card style={{marginBottom:10}}>
	                <Card.Header style={{backgroundColor:'transparent',marginLeft:20,marginRight:20,paddingLeft:0,paddingRight:0}}>
	                    <Card.Text style={{fontWeight:'bold',fontSize:18, color:'#0AC5BF'}}>Subscription Status</Card.Text>
	                </Card.Header>
	                <Card.Body style={{paddingLeft:20,paddingRight:20,fontSize:12,color:'#0AC5BF'}}>
	                    <div className="p-2 mb-2 d-flex align-items-center" style={{fontSize:12,borderBottom:'1px solid #eee',cursor:'pointer'}}>
            				<span><i className="bi bi-credit-card"></i> Current Subscription Plan: <b>Sapphire</b></span>
            				<span style={{marginLeft:'auto',color:'#999'}}><i className="bi bi-pencil"></i></span>
            			</div>
            			<div className="p-2 mb-2 d-flex align-items-center" style={{fontSize:12,borderBottom:'1px solid #eee',cursor:'pointer',color:'#033b39'}}>
            				<span><i className="bi bi-x-octagon"></i> Cancel Subscription</span>
            			</div>
	                </Card.Body>
	            </Card>
			</Container>
}